import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { TextPrimaryButton } from "../../../Default/LekUI/Button";
import QuestionSkeleton, {
	SingleQuestion as SingleQuestionSkeleton,
} from "../../Skeletons/Question";
import { PageSize } from "./index";
import QuestionView from "./QuestionView";

const Controller = (props) => {
	const { t } = useTranslation();

	return (
		<div className="flex items-center justify-between my-12">
			<TextPrimaryButton
				startIcon={<ArrowBackIcon />}
				onClick={props.onPrev}
				className="px-0"
			>
				{t("commands.prev")}
			</TextPrimaryButton>
			<span className="text-grey">
				{props.currentIndex + 1}/{props.allQuestions}
			</span>
			<TextPrimaryButton
				className="px-0"
				endIcon={<ArrowForwardIcon />}
				onClick={props.onNext}
			>
				{t("commands.next")}
			</TextPrimaryButton>
		</div>
	);
};

function QuestionsCarousel(props) {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setCurrentIndex(0);
	}, []);

	useEffect(() => {
		setIsLoading(true);
	}, []);

	useEffect(() => {
		setIsLoading(false);
	}, []);

	const getCurrentIndex = (index = currentIndex) => {
		return index + props.page * PageSize;
	};

	const onPrev = () => {
		if (getCurrentIndex(Math.max(currentIndex - 1, 0)) === 0) {
			setCurrentIndex(0);
		} else {
			if (currentIndex === 0) {
				props.setPage(props.page - 1);
			}
			setCurrentIndex(currentIndex === 0 ? PageSize - 1 : currentIndex - 1);
		}
	};

	const onNext = () => {
		if (getCurrentIndex(currentIndex + 1) >= props.count) {
			setCurrentIndex(currentIndex);
		} else {
			if (currentIndex + 1 === PageSize) {
				props.setPage(props.page + 1);
				setCurrentIndex(0);
			} else {
				setCurrentIndex(currentIndex + 1);
			}
		}
	};

	if (props.isLoading) {
		return <SingleQuestionSkeleton />;
	}

	const renderQuestionView = () => {
		if (isLoading) {
			return <QuestionSkeleton />;
		}

		return (
			<QuestionView
				className="question-view--flat"
				question={props.data[currentIndex]}
				answers={props.answers}
				setAnswer={props.setAnswer}
				searchValue={props.searchValue}
			/>
		);
	};

	return (
		<div className={props.className}>
			<Controller
				currentIndex={currentIndex + props.page * PageSize}
				allQuestions={props.count}
				onPrev={onPrev}
				onNext={onNext}
			/>
			<div className="search-elements--carusel">{renderQuestionView()}</div>
		</div>
	);
}

export default QuestionsCarousel;
